// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WGLt","title":"styles_title__sfepr"};